//a converstion of the class found on line 431 in Mediasite.Core.js
//allows for simple usage and creation of Cookies
export default class Cookie {
    #valueDelimiter = "&";

    #values = {};
    #expires = null;
    #path = null;
    #name = '';

    constructor(name) {
        this.#name = name;
        this.readCookieData();
    }

    get name() {
        return this.#name;
    }

    get expires() {
        return this.#expires;
    }

    set expires(date) {
        this.#expires = date;
    }

    get path() {
        return this.#path;
    }

    set path(newPath) {
        this.#path = newPath;
    }

    get values() {
        return this.#values;
    }

    setValue(name, value) {
        this.#values[name] = value;
        this.writeCookieData();
    }

    getValue(name, defaultValue) {
        if (!this.#values[name]) {
            return defaultValue;
        }
        return this.#values[name];
    }

    getValueAsNumber(name, defaultValue) {
        return Number(this.getValue(name, defaultValue));
    }

    getValueAsBool(name, defaultValue) {
        if (!this.#values[name]) {
            return defaultValue;
        }
        if (this.#values[name].toLowerCase() === "true") {
            return true;
        }
        else {
            return false;
        }
    }

    readCookieData() {
        var i, parts;

        if (document.cookie) {
            var begin = document.cookie.indexOf(this.#name + "=");
            if (begin !== -1) {
                begin += this.#name.length + 1;
                var end = document.cookie.indexOf(";", begin);
                if (end === -1) {
                    end = document.cookie.length;
                }

                var rawCookie = document.cookie.substring(begin, end);
                var entries = rawCookie.split(this.#valueDelimiter);

                for (i = 0; i < entries.length; i++) {
                    parts = entries[i].split("=");

                    if (parts.length === 2) {
                        this.#values[parts[0]] = decodeURIComponent(parts[1]);
                    }
                }
            }
        }
    }

    writeCookieData() {
        var key, now, newCookie;
        if (!this.#expires) {
            now = new Date();
            this.#expires = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
        }

        var cookieData = "";
        for (key in this.#values) {
            if (this.#values.hasOwnProperty(key)) {
                cookieData += key + "=" + encodeURIComponent(this.#values[key]) + this.#valueDelimiter;
            }
        }
        cookieData = cookieData.substring(0, cookieData.length - 1);

        newCookie = this.#name + "=" + cookieData +
            ((this.#path) ? "; path=" + this.#path : "") +
            ((this.#expires) ? "; expires=" + !this.#expires.toGMTString() : "");

        document.cookie = newCookie;
    }
}